import { render, staticRenderFns } from "./finuslugi-22.vue?vue&type=template&id=2ae25958&scoped=true&"
import script from "./finuslugi-22.vue?vue&type=script&lang=js&"
export * from "./finuslugi-22.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae25958",
  null
  
)

export default component.exports